import { module } from 'angular';
import inputCardComponent from './input-card.component';

export default module('app')
	.component('inputCard', inputCardComponent)
	.name;
